import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { API } from "../global";

// Task
// Validation - on Add movie & Edit movies
// name - required
// poster - min 4, required
// rating - 0 - 10, required
// summary - min 20 chars, required
// trailer -min 4, required

// /movies/add - AddMovie
export const formValidationSchema = yup.object({
  name: yup.string().required("Why not fill this name? 😉"),
  poster: yup
    .string()
    .required("Why not fill this poster? 😉")
    .min(4, "Need a bigger poster 😄"),
  summary: yup
    .string()
    .required("Why not fill this name? 😉")
    .min(20, "Need a bigger summary 😄"),
  rating: yup
    .number()
    .required("Why not fill this name? 😉")
    .min(0, "Good rating would be nice 😄")
    .max(10, "Too much rating 😅"),
  trailer: yup
    .string()
    .required("Why not fill this name? 😉")
    .min(4, "Need a bigger trailer 😄"),
});

export function AddMovie() {
  const { handleSubmit, values, handleChange, handleBlur, errors, touched } =
    useFormik({
      initialValues: {
        name: "",
        poster: "",
        summary: "",
        rating: "",
        trailer: "",
      },
      //   validate: formValidation,
      validationSchema: formValidationSchema,
      onSubmit: (newMovie) => {
        console.log("onSubmit", newMovie);
        addMovie(newMovie);
      },
    });

  const history = useHistory();

  const addMovie = (newMovie) => {
    // 1. method - POST
    // 2. body - data & JSON
    // 3. headers - JSON data

    fetch(`${API}/movies`, {
      method: "POST",
      body: JSON.stringify(newMovie),
      headers: { "Content-type": "application/json" },
    }) // returns a promise object
      .then(() => history.push("/movies"));
  };

  return (
    <form onSubmit={handleSubmit} className="add-movie-form">
      <TextField
        id="name"
        name="name"
        value={values.name}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie name"
        variant="outlined"
        error={errors.name && touched.name}
        helperText={errors.name && touched.name ? errors.name : ""}
      />

      <TextField
        id="poster"
        name="poster"
        value={values.poster}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Poster url"
        variant="outlined"
        error={errors.poster && touched.poster}
        helperText={errors.poster && touched.poster ? errors.poster : ""}
      />

      <TextField
        id="summary"
        name="summary"
        value={values.summary}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie summary"
        variant="outlined"
        error={errors.summary && touched.summary}
        helperText={errors.summary && touched.summary ? errors.summary : ""}
      />
      <TextField
        id="rating"
        name="rating"
        value={values.rating}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie rating"
        variant="outlined"
        error={errors.rating && touched.rating}
        helperText={errors.rating && touched.rating ? errors.rating : ""}
      />
      <TextField
        id="trailer"
        name="trailer"
        value={values.trailer}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie trailer"
        variant="outlined"
        error={errors.trailer && touched.trailer}
        helperText={errors.trailer && touched.trailer ? errors.trailer : ""}
      />
      <Button variant="contained" type="submit">
        Add movie
      </Button>
    </form>
  );
}
